<ng-container *ngIf="loading; else content">
  <div class="hidden-content">
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </div>

  <sd-spinner class="spinner"></sd-spinner>
</ng-container>

<ng-template #content>
  <cx-icon class="icon" *ngIf="icon" [type]="icon"></cx-icon>
  <ng-content></ng-content>
</ng-template>
